import * as c from '../constants/backups'

export const load = ()=>({
	type: c.BACKUPS_LOAD_REQ
})